export const DESKTOP_APP_DOWNLOAD_URL = "https://app.gitpod.io/releases/desktop/stable/Ona.dmg";
